/**
 * placement_cull — play-mode rules for admin placements (2026-09-08, the
 * minimal tier). The 1,501 admin-placed objects in the Commons used to render
 * at full LOD0 for every client on every tier, all the time — 36.7 M of a
 * potato frame's 37.0 M triangles, and nothing in the graphics menu touched
 * them. Now a placement is instanced only inside the tier's object draw
 * distance (`farCull`, with hysteresis so a player at the edge never churns
 * loads) and at the tier's `placementLod` cooked variant (props fall back to
 * their nearest lower level). Pure; the editor module applies it.
 */
export const PLACEMENT_CULL_EVERY = 30;
/** A placement already instanced stays until it is this far past the cull distance. */
export const PLACEMENT_CULL_HYSTERESIS = 1.15;

export function placementWanted(dist: number, farCull: number, isIn: boolean): boolean {
  return isIn ? dist <= farCull * PLACEMENT_CULL_HYSTERESIS : dist <= farCull;
}

export function placementLodFor(preset: { placementLod?: number }): 0 | 1 | 2 | 3 {
  const l = Math.round(preset.placementLod ?? 0);
  return (l < 0 ? 0 : l > 3 ? 3 : l) as 0 | 1 | 2 | 3;
}
